"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaCobranca = exports.yupCobranca = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupCobranca = yup.object({
    idMensal: yup.number().nullable().default(0).label('Id Mensal'),
    recno: yup.number().nullable().default(0).label('RecNo'),
    bloqueto: yup.string().nullable().default('').label('Bloqueto'),
    dia_venc: (0, utils_1.sge2Date)().default(new Date().toISOString()).label('Dia vencimento'),
    codigoAluno: yup.string().nullable().default('').label('Código aluno SG2'),
    idAluno: yup.number().nullable().default(0).label('Id Aluno'),
    boldesc: yup.number().nullable().default(0).label('Boleto desconto'),
    tipo: yup.string().nullable().default('').label('Tipo'),
    parc: yup.string().nullable().default('').label('Número parcela'),
    item: yup.string().nullable().default('').label('Produto SG2'),
    idProduto: yup.number().nullable().default(0).label('Id produto'),
    nome_produto: yup.string().nullable().default('D').label('Nome produto'),
    data_imp: (0, utils_1.sge2Date)().default(new Date().toISOString()).label('Data impressão'),
    data: (0, utils_1.sge2Date)().default(new Date().toISOString()).label('Data geração SG2'),
    empresa: yup.number().nullable().default(0).label('Empresa SG2'),
    idEmpresa: yup.number().nullable().default(0).label('Id empresa'),
    cobranca: yup.boolean().nullable().default(false).label('Cobrança'),
    reg_data: (0, utils_1.sge2Date)().default(new Date().toISOString()).label('Data registro'),
    aut_multa: yup.boolean().nullable().default(false).label('Sem Multa e Juros'),
    nparcartao: yup.number().default(0).label('Qtde parcelas cartão'),
    vr_rec: yup.number().nullable().default(0).label('Valor recebimento'),
    desconto: yup.number().default(0).label('Desconto %'),
    valor: yup.number().default(0).label('Valor'),
    valorCurso: yup.number().default(0).label('Valor Curso'),
    acrescimo: yup.number().default(0).label('Valor'),
    descdia: yup.boolean().nullable().default(false).label('Desconto para pagamento em dia'),
    diascdesc: yup.number().default(0).label('Dias antecedentes para concessão do desconto'),
    dutilcdesc: yup
        .boolean()
        .nullable()
        .default(false)
        .label('Considerar dia útil p / dias antecedentes para concessão do desconto'),
    valordesc: yup.number().default(0).label('Valor desconto'),
    desc_perc: yup.boolean().nullable().default(false).label('Valor Curso'),
    diasAtraso: yup.number().default(0).label('Dias atraso'),
    som1desc: yup
        .boolean()
        .nullable()
        .default(false)
        .label('Se aluno possui bolsa, não dar desc. p/ pgto em dia da Turma'),
    agrup_resp: yup.boolean().nullable().default(false).label('Agrupar mensalidade por responsável'),
    agrup_venc: yup.boolean().nullable().default(false).label('Agrupar mensalidade por vencimento'),
    agrup_tp: yup.string().nullable().default('D').label('Tipo agrupamento vencimento: Dia ou Mês'),
    nome_escola: yup.string().nullable().default('').label('Nome escola'),
    endereco_escola: yup.string().nullable().default('').label('Nome escola'),
    cidade_escola: yup.string().nullable().default('').label('Cidade escola'),
    uf_escola: yup
        .string()
        .label('UF escola')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    impdescdia: yup.boolean().nullable().default(false).label('Conceder bolsa (mensal) somente para pagamento em dia'),
    codigoEscola: yup.string().nullable().default('').label('Codigo escola SG2'),
    idEscola: yup.number().nullable().default(0).label('Id escola'),
    car_juros: yup.number().default(0).label('Dias de carência'),
    ver_exp: yup.string().nullable().default('').label('Versão exportador'),
    cod_resp: yup.string().nullable().default('').label('Código responsável aluno sge2, tab: Aluno'),
    idResponsavel: yup.number().nullable().default(0).label('Id responsável'),
    cabeca: yup.boolean().nullable().default(false).label('Aluno cabeça'),
    agrupar: yup.boolean().nullable().default(false).label('Aluno agrupar'),
    nome_aluno: yup.string().nullable().default('').label('Nome aluno'),
    login: yup.string().nullable().default('').label('Login Aluno'),
    senha: yup.string().nullable().default('').label('Senha Aluno'),
    descperson_curso: yup.boolean().nullable().default(false).label('Desconto personalizado curso'),
    codigoCurso: yup.string().nullable().default('').label('Código curso sge2'),
    idCurso: yup.number().nullable().default(0).label('Id curso'),
    nome_curso: yup.string().nullable().default('').label('Nome curso'),
    categoria: yup.string().nullable().default('').label('Categoria SG2'),
    idCategoria: yup.number().nullable().default(0).label('Id categoria'),
    classe: yup.string().nullable().default('').label('Classe SG2'),
    idClasse: yup.number().nullable().default(0).label('Id categoria'),
    tabdescuni: yup.boolean().nullable().default(false).label('Tabela de desconto'),
    valor_no_curso: yup.number().nullable().default(0).label('Valor no curso'),
    codBanco: yup.string().nullable().default('').label('Conta - código banco'),
    agencia: yup.string().nullable().default('').label('Conta - agência'),
    conta: yup.string().nullable().default('').label('Conta - conta'),
    carteira: yup.string().nullable().default('').label('Conta - carteira'),
    titular: yup.string().nullable().default('').label('Conta - titular'),
    cnpj: yup.string().nullable().default('').label('Conta - CNPJ'),
    registrada: yup.boolean().nullable().default(false).label('Conta - registrada'),
    convenio: yup.string().nullable().default('').label('Conta - convênio'),
    montagem: yup.string().nullable().default('').label('Conta - montagem'),
    impVencMat: yup.string().nullable().default('').label('Conta - Imprime data de vencto no carnê - p/ as matrículas'),
    impVencimento: yup
        .boolean()
        .nullable()
        .default(false)
        .label('Imprime data de vencto no carnê - p/ diferente de matrículas'),
    tipoCobran: yup.string().nullable().default('').label('Conta - Tipo cobrança'),
    env_resp: yup.boolean().nullable().default(false).label('Conta - endereço de cobrança do responsável'),
    env_nome: yup.string().nullable().default('').label('Conta - Nome no bloqueto - Resp, Aluno ou p/ os 2'),
    impDescBlo: yup.boolean().nullable().default(false).label('Conta - Imprime desconto no carnê'),
    imp_vr_int: yup.boolean().nullable().default(false).label('Conta - Imprime valor integral no carnê'),
    impvrdesc: yup.boolean().nullable().default(false).label('Conta - Imprime valor no campo desc. do bloqueto'),
    imptarifa: yup.boolean().nullable().default(false).label('Conta - Imprime tarifa'),
    ibloqcurso: yup.boolean().nullable().default(false).label('Conta - Imprime nome do curso no bloqueto'),
    tipomsg: yup.number().nullable().default(0).label('Conta - Tipo mensagem'),
    ibloqturma: yup.boolean().nullable().default(false).label('Conta - Imprime turma no bloqueto'),
    impchamada: yup.boolean().nullable().default(false).label('Conta - Imprime número de chamada'),
    codigoConta: yup.string().nullable().default('').label('Conta - Código conta SG2'),
    idConta: yup.number().nullable().default(0).label('Id Conta'),
    sistbanco: yup.string().nullable().default('').label('Conta - Tipo sistema banco'),
    codservico: yup.string().nullable().default('').label('Conta - código serviço'),
    nome_resp: yup.string().nullable().default('').label('Cliente - Nome responsável'),
    cpf_resp: yup.string().nullable().default('').label('Cliente - CPF responsável'),
    senha_cliente: yup.string().nullable().default('').label('Cliente - senha'),
    login_cliente: yup.string().nullable().default('').label('Cliente - login'),
    email_cliente: yup.string().nullable().default('').label('Cliente - e-mail'),
    tipopessoa: yup.string().nullable().default('').label('Cliente - Tipo pessoa'),
    cnpj_resp: yup.string().nullable().default('').label('Cliente - CNPJ'),
    titulo_turma: yup.string().nullable().default('').label('Serie - Titulo turma'),
    serie: yup.string().nullable().default('').label('Serie SGE2'),
    idSerie: yup.number().nullable().default(0).label('Serie - Id Serie'),
    nome_serie: yup.string().nullable().default('').label('Serie - Nome serie'),
    turno: yup.string().nullable().default('').label('Serie - Turno'),
    codigoturma: yup.string().nullable().default('').label('Serie - Codigo Turma SG2'),
    idTurma: yup.number().nullable().default(0).label('Serie - Id Serie'),
    fcalcjuros: yup.number().default(0).label('Tipo Cálculo de Juros'),
    multa: yup.number().default(0).label('Multa'),
    juros: yup.number().default(0).label('Juros'),
    tipodesconto: yup.string().nullable().default('').label('Tipo desconto'),
    mensagem: yup.string().nullable().default('').label('Mensagem cobrança'),
    feriados: yup.string().nullable().default('').label('Feriados'),
});
exports.schemaCobranca = exports.yupCobranca.shape({});
